import {Fragment} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Field, reduxForm, reset, SubmissionError} from 'redux-form';
import {Button, Form, Message} from 'semantic-ui-react';
import FormInput from '../shared/forms/input';
import {mobile, required} from '../shared/forms';
import {loginUser} from '../../redux/actions/auth';
import {Link} from 'react-router-dom';

function LoginForm(props) {
  const {handleSubmit, pristine, submitting, error} = props;

  return (
    <Fragment>
      {/*form error*/}
      {(error && !pristine) && (
        <Message
          error
          header={error}
          className={'text-center'}
        />
      )}

      {/*form*/}
      <Form onSubmit={handleSubmit(submit.bind(null, props))}>
        <Field
          required
          name='mobile'
          label='شماره تلفن همراه'
          type='tel'
          placeholder='09121234567'
          component={FormInput}
          validate={[required, mobile]}
        />
        <Field
          required
          name='password'
          label='رمز عبور'
          type='password'
          component={FormInput}
          validate={required}
        />
        <Button
          type='submit'
          disabled={pristine || submitting}
          content='ورود'
        />
        <Button
          as={Link}
          to='/forget-password'
          content='بازیابی رمز عبور'
        />
      </Form>
    </Fragment>
  );
}

async function submit(props, values) {
  try {
    await props.loginUser(values);
    await props.reset();
  } catch (error) {
    const errorMessage = error.message || 'شماره تلفن یا رمز عبور نادرست است.';
    throw new SubmissionError({_error: errorMessage});
  }
}

export default compose(
  connect(null, {loginUser, reset}),
  reduxForm({form: 'login'})
)(LoginForm);
